import {reject} from 'rambda'
import {anyPass} from 'rambda'
import {isEmpty} from 'rambda'
import {isNil} from 'rambda'

export const removeEmptyProperties = (object: {[key: string]: any}): {[key: string]: any} => reject(anyPass([isEmpty, isNil]), object)
